import React from "react";
import { DataTableDataType, FormatterType, IconFormatter } from "best-common-react";
import { Link, useLocation } from "react-router";

const IconLinkFormatter = <T extends DataTableDataType>(props: FormatterType<T>) => {
  const { value, rowIndex = -1 } = props;
  const location = useLocation();
  return (
    <Link to={value} id={rowIndex.toString()} className="w-100" state={{ previousLocation: location }}>
      <IconFormatter {...props} />
    </Link>
  );
};

export default IconLinkFormatter;
